import { Injectable } from '@angular/core';
import moment from 'moment';
import * as images from 'src/assets/config/images.json';
import { IImageSource } from 'projects/common/src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ImageProviderService {

  private readonly IMG_PATH = '../../assets/img';
  private readonly IMAGES: IImageSource[] = (images as any).default as IImageSource[];
  private $context: string;
  private get context(): string {
    return this.$context;
  }
  private set context(value: string) {
    this.$context = value;
    // TODO Logica para gatillar cambio de imagen
  }

  constructor(
  ) {
  }

  /**
   * Image and path format:
   * IMG_PATH/[type]/[project]-[key]-[reason].[extension]
   */

  /**
   * Functin to get the image
   * @param imageKey: Image key
   * @param hasError: If an image error exists
   */
  public getImage(imageType: string, imageKey: string, hasError?: boolean): string {
    const CURRENT_PROJECT = 'onemine'; // TODO: Obtain the project by service

    // If the request comes by error, returns the default path
    if (hasError) {
      return this.getDefaultImage(imageType, imageKey, CURRENT_PROJECT);
    }

    const image = this.IMAGES.find((img) =>
      Number(img.startDate.split('/')[1]) === (moment().month() + 1) && img.key === imageKey);

    if (image &&
      moment().date() >= Number(image.startDate.split('/')[0]) &&
      moment().date() <= Number(image.endDate.split('/')[0]) &&
      image.project === CURRENT_PROJECT) {
      const imgPath = `${this.IMG_PATH}/${image.type}/${image.project}-${image.key}-${image.name}.${image.extension}`;
      return imgPath;
    }

    return this.getDefaultImage(imageType, imageKey, CURRENT_PROJECT);
  }

  /**
   * Function that return the default image by key-project
   * @param imageKey: Image key
   * @param project: Image project
   */
  public getDefaultImage(imageType: string, imageKey: string, project: string): string {
    // TODO: Change the extension
    return `${this.IMG_PATH}/${imageType}/${project}-${imageKey}-default.svg`;
  }

  public setContext(value: string): void {
    if (value && value !== this.context) {
      this.context = value;
    }
  }
}
